const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/side-staple-machines`,
    saveSpeedTable: `${API_URL}/side-staple-machine/save-speed-table`
};

export default apiUrls;
